import validate from "/home/runner/work/pos-frontend/pos-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45subdomain_45global from "/home/runner/work/pos-frontend/pos-frontend/middleware/00-subdomain.global.js";
import _01_45offline_45pos_45global from "/home/runner/work/pos-frontend/pos-frontend/middleware/01-offline-pos.global.js";
import _02_45password_45change_45global from "/home/runner/work/pos-frontend/pos-frontend/middleware/02-password-change.global.js";
export const globalMiddleware = [
  validate,
  _00_45subdomain_45global,
  _01_45offline_45pos_45global,
  _02_45password_45change_45global
]
export const namedMiddleware = {
  cashier: () => import("/home/runner/work/pos-frontend/pos-frontend/middleware/cashier.js"),
  "index-guard": () => import("/home/runner/work/pos-frontend/pos-frontend/middleware/index-guard.js")
}